import { APP_INITIALIZER, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { RbUiComponentsModule } from '@inst-iot/bosch-angular-ui-components'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { CoreModule } from './core/core.module'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { MsalRedirectComponent } from '@azure/msal-angular'
import { InternalModule } from './internal/internal.module'
import { CustomerModule } from './customer/customer.module'
import { ToastsContainer } from './shared/components/toasts-container/toasts-container.component'

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent, MsalRedirectComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RbUiComponentsModule,
    CoreModule,
    NgbModule,
    InternalModule,
    CustomerModule,
    ToastsContainer,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {}
